module.exports = __webpack_public_path__ + "static/img/ios_fil.276b13de.png";